module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-datatable', {
    staticStyle: {
      "cursor": "pointer !important"
    },
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "hasDownload": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "hasMultiSearch": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total_pages,
      "custom-pagination-total-items": _vm.total,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.selectedRowData($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.filters = $event;
        _vm.doSearch();
      },
      "deleteOnFilter": function($event) {
        return _vm.delByOneFilter($event)
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8a7aa58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/partnership/components/PartnershipProgramDialog.vue
// module id = 2204
// module chunks = 1